export default __webpack_public_path__ + "media/music/87b6827bb54c4924fc262eda16bbafb2.mp3";